<template>
  <button-toggle
    class="_favorite"
    icon-href="#favorite"
    :active="active"
    :size="size"
    title-active="В избранном"
    title-inactive="Добавить в избранное"
    isFavorite="true"
    @click="onClick"
  />
</template>

<script>
import ButtonToggle from '@@/shared/form/ButtonToggle';

export default {
  components: {
    ButtonToggle
  },

  props: {
    active: {
      type: Boolean,
      required: true
    },
    size: {
      type: Number,
      default: 20
    }
  },

  methods: {
    onClick(active) {
      this.$emit('click', active);
    }
  }
};
</script>
